// Duitse teksten van aanmelden en abonnement (zie billingApp.nl.ts).
export const appBillingDe = {
    signup: {
        steps: [
            'Willkommen',
            'Konto',
            'Bestätigen',
            'Haushalt',
            'Mitglieder',
            'Module',
            'Board',
            'Fertig',
        ],
        stepOf: 'Schritt {n} von {total}: {name}',
        welcomeTitle: 'Willkommen bei AMUMIN Family Board',
        welcomeBody: 'Ein ruhiges Board für euren Haushalt: der Kalender, Aufgaben und mehr, auf einem Tablet an der Wand und in dieser App.',
        trialLine: 'Der erste Monat ist kostenlos. Du musst jetzt keine Zahlungsdaten angeben.',
        languageLabel: 'In welcher Sprache möchtest du weitermachen?',
        start: 'Loslegen',
        closedTitle: 'Die Anmeldung ist noch nicht geöffnet',
        closedBody: 'Wir öffnen bald. Trag dich in die Warteliste ein, dann schicken wir dir eine Einladung.',
        closedLink: 'Zur Warteliste',
        haveAccount: 'Hast du schon ein Konto?',
        login: 'Anmelden',
        accountTitle: 'Dein Konto',
        accountBody: 'Damit meldest du dich an. Deine E-Mail-Adresse nutzen wir nur für dein Konto, nie für Werbung.',
        name: 'Dein Vorname',
        nameHint: 'So nennt dich das Board. Später änderbar.',
        nameRequired: 'Gib deinen Vornamen ein.',
        email: 'E-Mail-Adresse',
        method: 'Wie möchtest du dich anmelden?',
        methodPassword: 'Mit einem Passwort',
        methodLink: 'Schick mir einen Link',
        methodLinkHint: 'Du bekommst einen Code und eine Schaltfläche per E-Mail. Ein Passwort kannst du später jederzeit wählen.',
        priceLine: '1 Monat kostenlos, danach {price} pro Monat. Du kannst jederzeit kündigen.',
        priceLinePlaceholder: '1 Monat kostenlos, danach zahlst du monatlich. Den Preis erfährst du rechtzeitig vor dem Ende. Du kannst jederzeit kündigen.',
        termsBefore: 'Ich akzeptiere die',
        termsLink: 'Bedingungen',
        termsAnd: 'und die',
        privacyLink: 'Datenschutzerklärung',
        termsRequired: 'Hake das an, um weiterzumachen.',
        createAccount: 'Konto erstellen',
        verifyTitle: 'Bestätige deine E-Mail-Adresse',
        verifyIntro: 'Wir haben einen Code an {email} geschickt. Gib ihn unten ein oder klick auf die Schaltfläche in der E-Mail.',
        verifyHint: 'Keine E-Mail? Schau auch im Spam-Ordner nach oder fordere unten einen neuen Code an.',
        otherEmail: 'Andere E-Mail-Adresse',
        linkBusy: 'Deine E-Mail-Adresse wird bestätigt…',
        linkVerifiedTitle: 'Deine E-Mail-Adresse ist bestätigt',
        linkVerifiedBody: 'Dein Probemonat hat begonnen. Mach in dem Browser weiter, in dem du angefangen hast, oder melde dich hier an.',
        linkInvalid: 'Dieser Link ist abgelaufen oder wurde schon benutzt. Melde dich an oder registriere dich neu.',
        modulesTitle: 'Was möchtest du nutzen?',
        modulesBody: 'Alles ist freiwillig. Für eure Art von Haushalt ist das hier schon eingeschaltet; schalte ein oder aus, was du möchtest. Ändern kannst du das später jederzeit unter Einstellungen › Module.',
        profileTitle: 'Glaube, Essen und besondere Tage',
        profileBody: 'Nur wenn du möchtest. Du wählst selbst und gibst dafür eine eigene Einwilligung.',
        profileButton: 'Auswählen',
        boardTitle: 'Ein Tablet als Board',
        boardBody: 'Häng ein Tablet an die Wand und verbinde es mit dem QR-Code. Kein Tablet zur Hand? Das geht auch später, unter Einstellungen › Tablets.',
        boardQr: 'Mit QR-Code verbinden',
        boardCode: 'Mit einem Code verbinden',
        doneTitle: 'Willkommen, alles ist bereit',
        doneTrial: 'Dein Probemonat läuft bis einschließlich {date}.',
        doneNext: [
            'Eine Woche vor dem Ende schicken wir dir eine Erinnerung.',
            'Möchtest du danach weitermachen? Füge deine Zahlungsdaten unter Einstellungen › Abonnement hinzu. Wenn du nichts tust, kannst du alles noch ansehen, aber nicht mehr ändern.',
            'Du kannst jederzeit kündigen. Wir löschen nie von selbst etwas.',
        ],
        toApp: 'Zur App',
    },
    page: {
        title: 'Abonnement',
        settingsHint: 'Probemonat, Bezahlen und Rechnungen',
        offTitle: 'Noch keine Abonnements',
        offBody: 'Du nutzt AMUMIN Family Board zurzeit ohne Abonnement.',
        noneTitle: 'Kein Abonnement nötig',
        noneBody: 'Dieses Familien-Board hat kein Abonnement.',
        status: {
            trial: 'Probemonat',
            active: 'Aktiv',
            past_due: 'Zahlung fehlgeschlagen',
            paused: 'Pausiert',
            cancelled: 'Gekündigt',
            expired: 'Nur ansehen',
        },
        trialLeft: 'Noch {n} Tage kostenlos, bis einschließlich {date}.',
        trialLastDay: 'Heute ({date}) ist dein letzter kostenloser Tag.',
        activeUntil: 'Bezahlt bis {date}.',
        activeOpen: 'Dein Abonnement läuft.',
        cancelledUntil: 'Gekündigt. Alles funktioniert noch bis einschließlich {date}.',
        expiredBody: 'Dein Probemonat ist vorbei. Alles ist noch da; ändern kannst du wieder nach dem Bezahlen.',
        pastDueBody: 'Die letzte Zahlung ist fehlgeschlagen. Füge erneut Zahlungsdaten hinzu.',
        pausedBody: 'AMUMIN hat dein Abonnement kurz pausiert. Alles funktioniert ganz normal.',
        plan: 'Tarif',
        perMonth: '{price} pro Monat',
        pricePlaceholder: 'Preis folgt',
        payment: 'Zahlungsdaten',
        paymentNone: 'Noch keine Zahlungsdaten.',
        paymentSet: 'Die Lastschrift ist eingerichtet.',
        addPayment: 'Zahlungsdaten hinzufügen',
        soon: 'Bald: Bezahlen mit iDEAL und danach per Lastschrift.',
        checkoutTitle: 'Zahlungsdaten hinzufügen',
        checkoutBody: 'Den ersten Monat bezahlst du mit iDEAL. Danach buchen wir jeden Monat automatisch ab. Du kannst jederzeit kündigen.',
        startNow: 'Ich möchte, dass der Dienst sofort weiterläuft. Wenn ich innerhalb von 14 Tagen widerrufe, zahle ich nur für die Tage, die ich schon genutzt habe.',
        startNowRequired: 'Hake das an, um weiterzumachen.',
        toPayment: 'Zum Bezahlen',
        checkoutOpen: 'Es läuft bereits eine Zahlung. Schließe sie zuerst ab oder versuche es in einer Stunde erneut.',
        paidReturn: 'Danke. Sobald die Zahlung eingegangen ist, siehst du es hier.',
        invoices: 'Rechnungen',
        invoicesNone: 'Noch keine Rechnungen.',
        invoiceStatus: {
            open: 'Offen',
            paid: 'Bezahlt',
            failed: 'Fehlgeschlagen',
            refunded: 'Erstattet',
            void: 'Ungültig',
        },
        invoiceLine: '{number} · {period} · {amount}',
        cancel: 'Abonnement kündigen',
        cancelTitle: 'Abonnement kündigen?',
        cancelBody: 'Alles funktioniert noch bis einschließlich {date}. Danach kannst du alles noch ansehen, aber nicht mehr ändern. Wir löschen nichts.',
        cancelConfirm: 'Ja, kündigen',
        keep: 'Doch nicht',
        cancelDone: 'Dein Abonnement ist gekündigt.',
        resume: 'Doch weitermachen',
        resumeDone: 'Schön, dein Abonnement läuft weiter.',
        onlyOwner: 'Nur der Eigentümer kann bezahlen oder kündigen.',
        deleteHint: 'Möchtest du alles löschen? Das geht unter Einstellungen › Deine Daten.',
    },
    banner: {
        expiredTitle: 'Dein Probemonat ist vorbei',
        expiredBody: 'Du kannst alles noch ansehen. Füge Zahlungsdaten hinzu, um wieder etwas hinzuzufügen und zu ändern.',
        pay: 'Bezahlen',
        readOnly: 'Dein Probemonat ist vorbei: Ändern geht wieder nach dem Bezahlen.',
    },
    terms: {
        title: 'Bedingungen (Entwurf)',
        intro: 'Das ist ein Entwurf. Die endgültigen Allgemeinen Geschäftsbedingungen stehen hier, bevor die Anmeldung öffnet.',
        points: [
            'Der erste Monat ist kostenlos. Dafür musst du keine Zahlungsdaten angeben.',
            'Danach zahlst du monatlich oder jährlich, im Voraus. Kündigen kannst du jederzeit; es läuft dann bis zum Ende des bezahlten Zeitraums.',
            'Nach dem Probemonat ohne Zahlung kannst du alles noch ansehen, aber nicht mehr ändern. Wir löschen nie von selbst etwas.',
            'Als Verbraucher hast du ein Widerrufsrecht von 14 Tagen ab dem Moment, in dem du anfängst zu bezahlen.',
            'Wie wir mit deinen Daten umgehen, steht in der Datenschutzerklärung.',
        ],
    },
};
//# sourceMappingURL=billingApp.de.js.map